export type MunicipalityKey = {
    number: number;
    name: string;
}

export default function calculateMunicipalityKey() {
    return findMunicipalityKey();
}

function findMunicipalityKey(): MunicipalityKey {
    let municipalities: MunicipalityKey[] = [
         { number: 4203, name: "arendal" },
         { number: 4217, name: "amli" },
         { number: 4214, name: "froland" },
         { number: 4211, name: "gjerstad" },
         { number: 4202, name: "grimstad" },
         { number: 4218, name: "iveland" },
         { number: 4201, name: "risor" },
         { number: 4213, name: "tvedestrand" },
         { number: 4212, name: "vegarshei" },
         { number: 4223, name: "vennesla" },
         { number: 4221, name: "valle" },
         { number: 4222, name: "bykle" },
         { number: 4220, name: "bygland" }
    ];
    let hostName = window.location.hostname;
    let determinedState: MunicipalityKey | undefined = undefined;
    municipalities.forEach((c) => {
        if (hostName.includes(c.name))
            determinedState = c;
    });

    if (!determinedState || determinedState == undefined){
        // find city from querystring
        const queryParams = new URLSearchParams(window.location.search);
        var parameter = queryParams.get('kommune') ?? '';
        municipalities.forEach((c) => {
            if (parameter.toLowerCase().includes(c.name)){
                determinedState = c;
            }
        });
    }

    if(!determinedState){
        // try to get from localstorage
        const storedMunicipality = localStorage.getItem('municipality');
        const foundMunic = municipalities.filter(m => m.name === storedMunicipality);
        if (foundMunic && foundMunic.length > 0) {
            determinedState = foundMunic[0];
            console.log('State set from localstorage', determinedState);
        }
    }

    return determinedState || { number: 4203, name: "arendal " } as MunicipalityKey;
}